<template>
    <el-card :body-style="{ padding: '0px 0.5rem' }" :class="[
        'image-item-card',
        $machineListStyle[element.status],
        element.checked ? 'image-item__checked' : 'image-item__unchecked',
        element.isDemo ? 'image-item__is-demo' : 'image-item__is-normal',
        element.isDemoMachineDisabled ? 'image-item__demo-expired' : '',
    ]" shadow="always">
        <div class="d-flex flex-column">

            <div class="d-flex flex-row machine-item">
                <div class="hidden-sm-and-down mr-5">
                    <Lable :element="element" />
                </div>
                <el-collapse accordion class="d-block d-md-none w-100">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <div class="w-100">
                                <div class="d-flex flex-row justify-content-between align-items-center">
                                    <div>
                                        <div class="d-flex flex-row align-items-center" style="font-family: Montserrat">
                                            <div>
                                                <span class="row-index-label">
                                                    # {{ index + 1 }}
                                                </span>
                                            </div>
                                            <div class="d-flex justify-content-center align-items-center ml-2 dotted-indicator"
                                                :class="`${element.status === 32773 || element.status === 10 ? 'blink_me' : ''}`"
                                                style=" border-radius: 1rem; height: 0.75rem; width: 0.75rem; "
                                                :style="`background-color: ${$machineStatusDotColor[element.status]};`">
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <strong class="ml-2 text-muted image-id-mobile">
                                                    {{ element.id }}
                                                </strong>
                                                <strong v-if="!element.isDemo" class="ml-2 text-primary image-name-mobile">
                                                    <v-clamp autoresize :max-lines="1">{{ element.name }}</v-clamp>
                                                </strong>
                                                <div v-if="element.isDemo" class="ml-2">
                                                    <span class="demo-image-label">
                                                        <i class="ri-flask-line" style="font-size: 120%;"></i>
                                                        <span>
                                                            {{ $t('machineItem.timeLeft') }} {{ element.demoRemainingSeconds |
                                                            secondDuration}}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-row align-items-center">
                                        <div v-if="element.status !== 2" class="vhdxLength mr-2 ml-2 mt-1">
                                            {{ element.vhdxLength | formatSize }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="element.isNotSupport" class="not-support-label mb-2 mr-2">
                                    <i class="el-icon-close"></i>
                                    <span class="ml-2">{{ $t('machineItem.notAvailable') }}</span>
                                </div>
                            </div>
                        </template>
                        <div class="mb-1">
                            <div class="d-flex">
                                <div class="flex-fill" style="width: calc(100vw - 12rem);">
                                    <div class="d-flex flex-row flex-wrap">
                                        <div v-if="!element.isNotSupport || element.snsCount"
                                            class="d-flex flex-row flex-wrap">
                                            <span v-if="element.hardwareFixation" class="mr-2 hardwareFixation mb-2">
                                                <i class="fas fa-thumbtack"></i>
                                                <span class="ml-2">{{ $t('machineItem.fixedMac') }}</span>
                                            </span>
                                            <span v-if="element.softwareLicenseEnabled"
                                                class="mr-2 softwareLicenseEnabled mb-2">
                                                <i class="el-icon-key"></i>
                                                <span class="ml-2">{{ $t('machineItem.license') }}</span>
                                            </span>
                                            <span v-if="element.fixedRental" class="mr-2 fixedRental mb-2">
                                                <i class="el-icon-date"></i>
                                                <span class="ml-2">{{ $t('bootMachine.rentalPlan') }}</span>
                                            </span>
                                            <span v-if="element.isDisconnectedInternet"
                                                class="mr-2 isDisconnectedInternet mb-2">
                                                <i class="el-icon-date"></i>
                                                <span class="ml-2">{{ $t('machineItem.disconnectedInternet') }}</span>
                                            </span>
                                            <el-tooltip class="item" effect="dark"
                                                :content="$t('machineItem.shutdownAt', { time: actions.formatTime(element.schedulerMachineShutdownMachineStartAt) })"
                                                placement="top">
                                                <span v-if="element.schedulerMachineShutdownMachineEnabled"
                                                    class="mr-2 schedulerMachineShutdownMachineEnabled mb-2">
                                                    <i class="el-icon-switch-button"></i>
                                                    <span class="ml-1">
                                                        {{ element.schedulerMachineShutdownMachineTimeRemaining }}
                                                    </span>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                    <Information :element="element" />
                                    <div v-if="element.cashbackAmount" class="d-flex align-items-center">
                                        <span class="text-muted"><i class="ri-arrow-go-back-line"></i>&nbsp;&nbsp;{{ $t('menu.creditBack') }}:&nbsp;&nbsp;</span>
                                        <strong class="d-flex align-items-center" style="color: #529421;">+{{
                                            element.cashbackAmount }}
                                            <ir-point class="ms-1" color="#529421" size="10px" /></strong>
                                    </div>
                                </div>
                                <div  class="ml-5">
                                    <el-button size="mini" circle="" plain @click="openContextmenuMobile(element)">
                                        <i style="color: #757575; font-size: 1.3rem" class="el-icon-s-operation"></i>
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex" class="mt-3 align-items-start w-100">
                            <Action class="flex-fill  justify-content-between" :element="element" @processingEvent="actions.processingEvent" />
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </el-card>
</template>


<script>
import EventBus from "@/event/EventBus";
import Lable from "@/views/component/RentalService/Lable";
//import ContextMenu from "@/views/component/RentalService/ContextMenu";
import Action from "@/views/component/RentalService/Action";
import Information from "@/views/component/RentalService/Information";
export default {
    components: {
        Action,
        Lable,
        //ContextMenu,
        Information,
    },
    props: {
        element: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: Number,
            default() {
                return -1
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    methods: {
        openContextmenuMobile(element) {
            EventBus.$emit("openContextmenuMobile", { isOpen: true, machineItem: element });
        }
    }
}
</script>